import React from 'react';
import { useAuth } from '@/lib/auth';
import SEOHead from '@/components/marketplace/SEOHead';
import ReviewsWidget from '@/components/marketplace/ReviewsWidget';
import { MessageCircle } from 'lucide-react';

/**
 * MyReviews — dedicated dashboard page for a seller to see every review
 * they've received in one place. Wired from the review-received bell
 * notification (see engagement_router.notify link) and reachable from the
 * dashboard sidebar. Reuses ReviewsWidget so styling stays consistent with
 * the public profile view.
 */
const MyReviews = () => {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className='space-y-6' data-testid='my-reviews-page'>
      <SEOHead title='My reviews · IndusFact' description='All reviews left by buyers on your IndusFact listings.' />
      <div>
        <div className='flex items-center gap-2 text-muted-foreground text-xs uppercase tracking-wider'>
          <MessageCircle className='h-3.5 w-3.5' /> Feedback from buyers
        </div>
        <h1 className='text-2xl sm:text-3xl font-semibold tracking-tight mt-1'>My reviews</h1>
        <p className='text-sm text-muted-foreground mt-1'>
          Every review a buyer has left about you. You can reply publicly to any review to protect your reputation.
        </p>
      </div>
      <ReviewsWidget sellerId={user.id} isOwner={true} />
    </div>
  );
};

export default MyReviews;
